import { IAppointmentScheduleResponse, IDoctorCheckInInfo } from "@curefit/care-common";
import { ConsultationPrescriptionItemRequest, Goal, UserGoalView } from "@curefit/gmf-common";
import * as _ from "lodash";
import * as React from "react";
import AdditionalInstructionsEditViewCont from "../../containers/EditView/AdditionalInstructionsEditViewCont";
import DietPlanEditViewCont from "../../containers/EditView/DietPlanEditViewCont";
import FitnessPlanEditViewCont from "../../containers/EditView/FitnessPlanEditViewCont";
import HabitsPlanEditViewCont from "../../containers/EditView/HabitsPlanEditViewCont";
import { LCGoalEditViewCont } from "../../containers/EditView/LCGoalEditViewCont";
import MindfulnessPlanEditViewCont from "../../containers/EditView/MindfulnessPlanEditViewCont";
import OtherGoalsEditViewCont from "../../containers/EditView/OtherGoalsEditViewCont";
import PatientPlanEligibilityEditViewCont from "../../containers/EditView/PatientPlanEligibilityEditViewCont";
import ErrorContainer from "../../containers/ErrorContainer";
import { MODAL_SCREENS } from "../../containers/Ongoing/OngoingConsultationContainer";
import IDietPlan from "../../models/IDietPlan";
import IDoctorProfile from "../../models/IDoctorProfile";
import IEditedBy from "../../models/IEditedBy";
import IFetchMealsByCaloriesRequest from "../../models/IFetchMealsByCaloriesRequest";
import { IFitnessActivities } from "../../models/IFitnessPrescription";
import IFoodCategory from "../../models/IFoodCategory";
import IMealItem from "../../models/IMealItem";
import IDishCatalogueResponse from "../../models/maverick/IDishCatalogueResponse";
import IMetric from "../../models/metrics/IMetric";
import ModelFactory from "../../models/ModelFactory";
import IOrionPlanResponse from "../../models/orion/IOrionPlanResponse";
import IPatientLifestylePlanWrapper from "../../models/patients/IPatientLifestylePlanWrapper";
import IStaticData from "../../models/staticData/IStaticData";
import {
    AppConstants,
    AppMessages,
    ConsultationStatusConstant,
    toastNotificationAppearance,
    CheckinType,
    APP_TENANTS
} from "../../utils/AppConstants";
import { default as AppUtils } from "../../utils/AppUtils";
import { HOME_PAGE_ROUTE, RouteUtils } from "../../routes";
import { EditViewDisplayMode } from "../common/EditViewCard";
import { IPlanMeta } from "../../../../common/models/IPlanRequestMeta";
import { PatientPersonalInformation } from "@curefit/ups-common";
import CTA, { CTATheme } from "../common/CallToAction";
import InterventionEditViewCont, { IIntervention } from "../../containers/EditView/InterventionEditViewCont";
import FitnessWODEditViewCont from "../../containers/EditView/FitnessWODEditViewCont/FitnessWODEditViewCont";

export interface PatientLifestylePlanTabProps {
    appointmentSchedule: IAppointmentScheduleResponse;
    editedBy?: IEditedBy;
    bookingId: number;
    appointmentId: number;
    patientId: number;
    secondaryUserId: string;
    consultationType: string,
    patientPlan: IPatientLifestylePlanWrapper;
    planMeta: IPlanMeta;
    patientFitnessPlan: IFitnessActivities[];
    patientDietPlan: IDietPlan;
    staticMealSlots: string[];
    staticMealPreferences: string[];
    fetchFitnessActivities: (input: string) => Promise<any>;
    fetchMindfulnessActivitiesByName: (input: string) => Promise<any>;
    staticFoodGroups: IFoodCategory[];
    fetchStaticFoodGroups: () => Promise<IFoodCategory[]>;
    fetchMealsByCalorie: (calorieBreakup: IFetchMealsByCaloriesRequest) => Promise<IMealItem[]>;
    saveEditedPatientProfile: (updatedPatientPlan: IPatientLifestylePlanWrapper | PatientPersonalInformation) => void;
    staticLifestyleHabits: IStaticData;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>
    reviewPlan: (flag: boolean, clearPdfData: boolean, modalScreen?: string, errorMessage?: string) => void;
    staticSpecialities: any[];
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    previewMeal: (meal: IMealItem) => Promise<IMealItem>;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    patientGoals: UserGoalView[];      // TODO: Remove after GMF integration
    patientSecondaryGoals: UserGoalView[];      // TODO: Remove after GMF integration
    patient_interventions: UserGoalView[];
    fetchStaticDietGuidelines: (input: string, category: string) => Promise<any[]>;
    savePatientPlanInDraft: (consultationId: number, patientPlan: IOrionPlanResponse) => Promise<any>;
    updateAppointmentStatus: (bookingId: number, appointmentId: number, status: ConsultationStatusConstant) => Promise<any>;
    doctorTypeInAdditionalInstructions: string;
    nextTab: () => void;
    doctorProfile: IDoctorProfile;
    isSelf: boolean;
    consultationId: number;
    patientPlanEligibilityInfo: any;
    staticPatientPlanEligibilityMaskAnswers: IStaticData[],
    updatePatientPlanEligibilityMasks: (userId: String, secondaryUserId: String, isSelf: Boolean, eligibilityMasks: String[]) => Promise<any>,
    newConfigData: any,
    staticGoals: Goal,
    staticMetrics: IMetric,
    suggestions: { [key: string]: any },
    appTenant?: string
}
export interface PatientLifestylePlanTabState {
    error: string;
    errorDetails: string;
}
export default class PatientLifestylePlanTab extends React.Component<PatientLifestylePlanTabProps, PatientLifestylePlanTabState> {
    private dietPlanRef: DietPlanEditViewCont;
    private fitnessPlanRef: FitnessPlanEditViewCont;
    private mindfulnessPlanRef: MindfulnessPlanEditViewCont;
    private habitsPlanRef: HabitsPlanEditViewCont;
    private additionalInstructionsRef: AdditionalInstructionsEditViewCont;
    private planEligibilityRef: PatientPlanEligibilityEditViewCont;
    private autoSaveTimer: number;
    private goalRef: LCGoalEditViewCont;
    private otherGoalsRef: OtherGoalsEditViewCont
    private interventionsRef: InterventionEditViewCont
    // private lifeStyleAdviceRef: LifeStyleAdviseEditViewCont;


    constructor(props: PatientLifestylePlanTabProps) {
        super(props);
        this.state = {
            error: null,
            errorDetails: null,
        }
    }

    componentWillUnmount() {
        if (AppUtils.isLifeStyleConsultation(this.props.appointmentSchedule)) this.saveEditedLifestyle();
        else if (this.props.doctorTypeInAdditionalInstructions === "MIND_THERAPIST") this.saveEditedLifestyleForTherapist();

        if (this.autoSaveTimer) clearInterval(this.autoSaveTimer);
    }

    getPlanSaveObjectForTherapist() {
        let patientPlan = !_.isEmpty(this.props.patientPlan) ? this.props.patientPlan : ModelFactory.createNewPatientPlan();
        let fitnessPrescription = this.props.appTenant !== APP_TENANTS.SUGARFIT ? this.fitnessPlanRef.getSaveObject() : {};
        let mindfulnessPrescription = this.mindfulnessPlanRef.getSaveObject();
        let habitsPrescription = this.habitsPlanRef.getSaveObject();
        let patientPlanEligibilityInfo = this.planEligibilityRef ? this.planEligibilityRef.getSaveObject() : undefined;
        let updatedPersonalInfo = { ...patientPlan, fitnessPrescription, mindfulnessPrescription, habitsPrescription, patientPlanEligibilityInfo };
        return updatedPersonalInfo;
    }

    getPlanSaveObject() {
        let patientPlan = !_.isEmpty(this.props.patientPlan) ? this.props.patientPlan : ModelFactory.createNewPatientPlan();
        // let cancelledDietPlans = !_.isEmpty(this.props.patientPlan.dietPrescription) ? this.props.patientPlan.dietPrescription.filter(item => item.status === AppConstants.planStatus.CANCELLED) : [];
        let dietPrescription = this.dietPlanRef.getSaveObject()
        let fitnessPrescription = this.props.appTenant !== APP_TENANTS.SUGARFIT ? this.fitnessPlanRef.getSaveObject() : {};
        let mindfulnessPrescription = this.mindfulnessPlanRef.getSaveObject();
        let habitsPrescription = this.habitsPlanRef.getSaveObject();
        let goals = this.goalRef.getSaveObject();
        let secondaryGoals = this.props.appTenant !== APP_TENANTS.SUGARFIT ? this.otherGoalsRef.getSaveObject() : {};
        const patient_interventions = this.props.appTenant === APP_TENANTS.SUGARFIT ? { ...this.interventionsRef.getSaveObject(), patientId: this.props.patientId } : {};
        // let consultations = this.additionalInstructionsRef.getConsultationPlanSaveObject();
        const referralInfoSet = this.additionalInstructionsRef.getReferralSaveObject();
        const followupInfoSet = this.additionalInstructionsRef.getFollowUpSaveObject();
        const immediateFollowup = {
            provideImmediateFollowup: this.additionalInstructionsRef.getImmediateFollowUp()
        }
        const prescriptionInstructions = {
            referralInfoSet,
            followupInfoSet,
            immediateFollowup,
            referenceId: this.props.consultationId.toString()
        }
        let patientPlanEligibilityInfo = this.planEligibilityRef ? this.planEligibilityRef.getSaveObject() : undefined;
        // const lifeStylePrescription = this.lifeStyleAdviceRef.getSaveObject();
        let updatedPersonalInfo = {
            // ...patientPlan,
            // dietPrescription,
            // fitnessPrescription,
            // mindfulnessPrescription,
            // habitsPrescription,
            // consultationsByLifestyleCoach: consultations,
            // patientGoals: goals,
            // patientSecondaryGoals: secondaryGoals,
            patientPlanEligibilityInfo
            // doctorAdvice: lifeStylePrescription

        };
        return {
            // updatedPersonalInfo,
            newConfigData: {
                ...this.props.newConfigData,
                healthTarget: goals,
                otherGoals: secondaryGoals,
                patient_interventions: { ...patient_interventions },
                fitnessPlan: fitnessPrescription,
                mindfulnessPlan: mindfulnessPrescription,
                dietPlan: dietPrescription,
                habits: habitsPrescription,
                prescriptionInstructions
            }
        };
    }

    saveEditedLifestyle() {
        let updatedPersonalInfo = this.getPlanSaveObject();
        this.props.saveEditedPatientProfile(updatedPersonalInfo as PatientPersonalInformation);
    }

    validateAndMoveToNextTab = () => {
        if (this.validatePlan()) {
            this.props.nextTab();
        } else {
            this.saveEditedLifestyleForTherapist();
            this.showValidationError();
        }
    }

    saveEditedLifestyleForTherapist() {
        let updatedPatientPlan = this.getPlanSaveObjectForTherapist();
        this.props.saveEditedPatientProfile(updatedPatientPlan as PatientPersonalInformation);
    }

    savePatientLifestylePlan() {
        this.saveEditedLifestyle();
        if (this.validatePlan()) {
            let updatedPersonalInfo = this.getPlanSaveObject();
            this.props.saveEditedPatientProfile(updatedPersonalInfo as PatientPersonalInformation);
            if (this.props.appTenant === APP_TENANTS.SUGARFIT && AppUtils.isLifeStyleConsultation(this.props.appointmentSchedule)) {
                this.props.reviewPlan(true, true, MODAL_SCREENS[11]);
            }
            else this.props.reviewPlan(true, true, MODAL_SCREENS[5]);
        } else {
            this.showValidationError();
        }
    }

    savePatientLifestylePlanInDraft() {
        this.saveEditedLifestyle();
        let planSaveObject = AppUtils.generateRedisPlanSaveObject(this.getPlanSaveObject(), this.props.appointmentId, this.props.patientId);
        let planWithMeta: IOrionPlanResponse = { meta: [{ userPlan: this.props.planMeta }], plan: planSaveObject };
        this.props.savePatientPlanInDraft(this.props.consultationId, planWithMeta).then(updatedPrescription => {
            return this.props.updateAppointmentStatus(this.props.bookingId, this.props.appointmentId, ConsultationStatusConstant.PRESCRIPTION_IN_DRAFT);
        }).then(() => {
            RouteUtils.navigateToHrefUrl("", HOME_PAGE_ROUTE);
        }).catch((err: any) => {
            // this.props.reviewPlan(true, true, MODAL_SCREENS[7], "PRESCRIPTION STATUS COULD NOT BE UPDATED");
            AppUtils.triggerToastNotification(`${err && err.message}`, toastNotificationAppearance.error)
        });
    }

    autoSaveLifestylePlanInRedis = async () => {
        // this.saveEditedLifestyle();
        let planSaveObject = AppUtils.generateRedisPlanSaveObject(this.getPlanSaveObject(), this.props.appointmentId, this.props.patientId);
        let planWithMeta: IOrionPlanResponse = { meta: [{ userPlan: this.props.planMeta }], plan: planSaveObject };
        await this.props.savePatientPlanInDraft(this.props.consultationId, planWithMeta)
    }

    componentDidMount(): void {
        this.autoSaveTimer = window.setInterval(() => {
            if (AppUtils.isLifeStyleConsultation(this.props.appointmentSchedule)) this.autoSaveLifestylePlanInRedis()
        }, 5000);
    }

    validatePlan() {
        let dietPlanStatus = this.dietPlanRef.isDietPlanDirty();
        let fitnessPlanStatus = this.props.appTenant !== APP_TENANTS.SUGARFIT ? this.fitnessPlanRef.isFormDirty() : false;
        let mindfulnessPlanStatus = this.mindfulnessPlanRef.isFormDirty();
        let habitsPlanStatus = this.habitsPlanRef.isFormDirty();
        let referralPlanStatus = this.additionalInstructionsRef.isReferralFormDirty();
        let followUpStatus = this.additionalInstructionsRef.isFollowUpFormDirty();
        // let doctorAdviceStatus = this.lifeStyleAdviceRef.isFormDirty();
        if (
            !dietPlanStatus &&
            !fitnessPlanStatus &&
            !mindfulnessPlanStatus &&
            !habitsPlanStatus &&
            !referralPlanStatus &&
            !followUpStatus
            // !doctorAdviceStatus
        ) {
            return true;
        } else return false;
    }

    showValidationError() {
        let dietPlanStatus = this.dietPlanRef.isDietPlanDirty();
        let fitnessPlanStatus = this.props.appTenant !== APP_TENANTS.SUGARFIT ? this.fitnessPlanRef.isFormDirty() : false;
        let mindfulnessPlanStatus = this.mindfulnessPlanRef.isFormDirty();
        let habitsPlanStatus = this.habitsPlanRef.isFormDirty();
        let referralPlanStatus = this.additionalInstructionsRef.isReferralFormDirty();
        let followUpStatus = this.additionalInstructionsRef.isFollowUpFormDirty();
        // const doctorAdviceStatus = this.lifeStyleAdviceRef.isFormDirty();
        if (dietPlanStatus) this.invalidItemError("Diet Plan", this.dietPlanRef.dirtyFormText())
        else if (fitnessPlanStatus && this.props.appTenant !== APP_TENANTS.SUGARFIT) this.invalidItemError("Fitness Plan", this.fitnessPlanRef.dirtyFormText());
        else if (mindfulnessPlanStatus) this.invalidItemError("Mindfulness Plan", this.mindfulnessPlanRef.dirtyFormText());
        else if (habitsPlanStatus) this.invalidItemError("Habits Plan");
        else if (referralPlanStatus) this.invalidItemError("Referral");
        else if (followUpStatus) this.invalidItemError("Follow Up");
        // else if (doctorAdviceStatus) {
        //     this.invalidItemError("LifeStyle Advice")
        // }
    }


    invalidItemError = (section: string, errorText?: string) => {
        this.setState({
            error: AppMessages.PLAN_VALIDATION_ERROR,
            errorDetails: `Error in ${section}. Please Review the form and proceed. ${!_.isEmpty(errorText) ? errorText : ""}`
        })
    }

    clearErrorMessage = () => {
        this.setState({
            error: null,
            errorDetails: null
        })
    }

    generatePatientReferrals = () => {
        let referrals: IDoctorCheckInInfo[] = [];
        _.map(this.props.patientPlan.consultationsByLifestyleCoach, (consultation: ConsultationPrescriptionItemRequest) => {
            if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.REFERRAL)
                referrals.push(ModelFactory.getAlbusReferralFromConsultationPlan(consultation))
        })
        return referrals;
    }

    generatePatientFollowUps = () => {
        let followUps: IDoctorCheckInInfo = ModelFactory.createNewDoctorCheckinInfo();
        _.map(this.props.patientPlan.consultationsByLifestyleCoach, (consultation: ConsultationPrescriptionItemRequest) => {
            if (!_.isEmpty(consultation.activities) && consultation.activities[0].checkinType === CheckinType.FOLLOWUP)
                followUps = ModelFactory.getAlbusReferralFromConsultationPlan(consultation);
        })
        return followUps;
    }

    getDietPrescriptionFromPlan = () => {
        let dietPlan = ModelFactory.createNewDietPlanPrescriptionItem();
        if (this.props.patientPlan && !_.isEmpty(this.props.patientPlan.dietPrescription) &&
            this.props.patientPlan.dietPrescription.filter(item => !item.onlyGuidelines && item.status !== AppConstants.planStatus.CANCELLED).length > 0) {
            dietPlan = this.props.patientPlan.dietPrescription.filter(item => !item.onlyGuidelines && item.status !== AppConstants.planStatus.CANCELLED)[0];
        }
        return dietPlan;
    }

    endAILCConsultation = () => {
        this.props.updateAppointmentStatus(this.props.bookingId, this.props.consultationId, ConsultationStatusConstant.COMPLETED).then(() => {
            RouteUtils.navigateToHrefUrl("", HOME_PAGE_ROUTE)
        })
    }

    render() {
        let dietPlan = this.props.newConfigData && this.props.newConfigData.dietPlan ? this.props.newConfigData.dietPlan : {};
        let fitnessPrescription = this.props.newConfigData && this.props.newConfigData.fitnessPlan ? this.props.newConfigData.fitnessPlan : {};
        let mindfulnessPrescription = this.props.newConfigData && this.props.newConfigData.mindfulnessPlan ? this.props.newConfigData.mindfulnessPlan : {};
        let habitsPlan = this.props.newConfigData && this.props.newConfigData.habits ? this.props.newConfigData.habits : {};
        let patientReferrals = this.props.newConfigData && this.props.newConfigData.prescriptionInstructions && this.props.newConfigData.prescriptionInstructions.referralInfoSet ? this.props.newConfigData.prescriptionInstructions.referralInfoSet : [];
        let patientFollowUp = this.props.newConfigData && this.props.newConfigData.prescriptionInstructions && this.props.newConfigData.prescriptionInstructions.followupInfoSet ? this.props.newConfigData.prescriptionInstructions.followupInfoSet : [];
        let errorMessage = !_.isNull(this.state.error) ? this.state.error : AppMessages.PRESCRIPTION_VALIDATION_ERROR;
        let errorDetails = this.state.errorDetails;
        let isLC = AppUtils.isLifeStyleConsultation(this.props.appointmentSchedule);
        let isTherapist = this.props.doctorTypeInAdditionalInstructions === "MIND_THERAPIST";
        const otherGoals = this.props.newConfigData.otherGoals && this.props.newConfigData.otherGoals.otherGoals
            ? this.props.newConfigData.otherGoals.otherGoals
            : [];

        const interventions: IIntervention[] = this.props.newConfigData.patient_interventions && this.props.newConfigData.patient_interventions.patientInterventionItemList ? this.props.newConfigData.patient_interventions.patientInterventionItemList : [];

        console.log("newConfig data----------->", this.props.newConfigData);
        const immediateFollowup = this.props.newConfigData && this.props.newConfigData.prescriptionInstructions && this.props.newConfigData.prescriptionInstructions.immediateFollowup && this.props.newConfigData.prescriptionInstructions.immediateFollowup.provideImmediateFollowup ? this.props.newConfigData.prescriptionInstructions.immediateFollowup.provideImmediateFollowup : false;
        return <div className="patient-lifestyle-plan-container">
            {
                !_.isNull(this.state.error) &&
                <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage} />
            }

            <div className="patient-info-subsection diet-plan-section">
                <LCGoalEditViewCont
                    newConfigData={this.props.newConfigData}
                    staticGoals={this.props.staticGoals}
                    staticMetrics={this.props.staticMetrics}
                    appointmentId={this.props.appointmentId}
                    ref={goalRef => this.goalRef = goalRef}
                    displayMode={EditViewDisplayMode.EDIT}
                />
            </div>



            {this.props.appTenant === APP_TENANTS.SUGARFIT ? <div className="patient-info-subsection diet-plan-section">
                <InterventionEditViewCont
                    interventions={interventions}
                    appointmentId={this.props.appointmentId}
                    ref={interventionsRef => this.interventionsRef = interventionsRef}
                />
            </div> : <div className="patient-info-subsection diet-plan-section">
                <OtherGoalsEditViewCont
                    otherGoals={otherGoals}
                    appointmentId={this.props.appointmentId}
                    ref={otherGoalsRef => this.otherGoalsRef = otherGoalsRef}
                />
            </div>}



            <div className="patient-info-subsection diet-plan-section">
                <DietPlanEditViewCont
                    consultationId={this.props.consultationId}
                    isSelf={this.props.isSelf} secondaryPatientId={this.props.secondaryUserId}
                    ref={(dietPlanDOM) => this.dietPlanRef = dietPlanDOM} editedBy={this.props.editedBy}
                    patientId={this.props.patientId} displayMode={isLC ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW}
                    patientDietPlan={dietPlan} staticMealSlots={["BREAKFAST"]} staticMealPreferences={[]}
                    staticFoodGroups={this.props.staticFoodGroups} fetchStaticFoodGroups={this.props.fetchStaticFoodGroups}
                    fetchMealsByCalorie={this.props.fetchMealsByCalorie} fetchDishByDishName={this.props.fetchDishByDishName}
                    fetchMealByMealId={this.props.fetchMealByMealId} previewMeal={this.props.previewMeal} createMeal={this.props.createMeal}
                    fetchStaticDietGuidelines={this.props.fetchStaticDietGuidelines} suggestions={this.props.suggestions} />
            </div>

            {this.props.appTenant === APP_TENANTS.SUGARFIT ? <div className="patient-info-subsection fitness-wod-section">
                <FitnessWODEditViewCont />
            </div>
                : <div className="patient-info-subsection fitness-plan-section">
                    <FitnessPlanEditViewCont isSelf={this.props.isSelf} secondaryPatientId={this.props.secondaryUserId} ref={(fitnessPlanDOM) => this.fitnessPlanRef = fitnessPlanDOM} editedBy={this.props.editedBy} patientId={this.props.patientId} fetchFitnessActivities={this.props.fetchFitnessActivities}
                        patientFitnessPlans={fitnessPrescription} displayMode={isLC || isTherapist ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW} consultationId={this.props.consultationId} doctorId={this.props.doctorProfile.id} doctorType={this.props.doctorTypeInAdditionalInstructions} doctorName={this.props.doctorProfile.name} cardTitleDisplay={"Fitness Plan"} />
                </div>}

            <div className="patient-info-subsection mindfulness-plan-section">
                <FitnessPlanEditViewCont isSelf={this.props.isSelf} secondaryPatientId={this.props.secondaryUserId} ref={(mindfulnessPlanDOM) => this.mindfulnessPlanRef = mindfulnessPlanDOM} editedBy={this.props.editedBy}
                    patientId={this.props.patientId} fetchFitnessActivities={this.props.fetchMindfulnessActivitiesByName}
                    patientFitnessPlans={mindfulnessPrescription} displayMode={isLC || isTherapist ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW} consultationId={this.props.consultationId} doctorId={this.props.doctorProfile.id} doctorType={this.props.doctorTypeInAdditionalInstructions} doctorName={this.props.doctorProfile.name} cardTitleDisplay={"Mindfulness Plan"} />
            </div>

            <div className="patient-info-subsection habit-section">
                <HabitsPlanEditViewCont consultationId={this.props.consultationId} isSelf={this.props.isSelf} secondaryPatientId={this.props.secondaryUserId} ref={(habitsPlanDOM) => this.habitsPlanRef = habitsPlanDOM} editedBy={this.props.editedBy} patientId={this.props.patientId}
                    fetchFitnessActivities={this.props.fetchFitnessActivities} patientHabitsPlan={habitsPlan}
                    staticLifestyleHabits={this.props.staticLifestyleHabits} displayMode={isLC || isTherapist ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW} />
            </div>
            <div className="patient-info-subsection additional-info-section">
                <AdditionalInstructionsEditViewCont isSelf={this.props.isSelf} secondaryPatientId={this.props.secondaryUserId} patientId={this.props.patientId} consultationType={this.props.consultationType} consultationId={this.props.appointmentId}
                    patientReferrals={patientReferrals} patientFollowUp={patientFollowUp} doctorType={this.props.doctorTypeInAdditionalInstructions} doctorProfile={this.props.doctorProfile}
                    displayMode={isLC ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW} ref={(referral) => { this.additionalInstructionsRef = referral }} staticSpecialities={this.props.staticSpecialities} immediateFollowUp={immediateFollowup} />
            </div>

            {/*<div className="patient-info-subsection">*/}
            {/*<LifeStyleAdviseEditViewCont*/}
            {/*patientId={this.props.patientId}*/}
            {/*patientLifeStyle={this.props.patientPlan.doctorAdvice}*/}
            {/*displayMode={isLC ? EditViewDisplayMode.EDIT : EditViewDisplayMode.VIEW}*/}
            {/*ref={(ref) => {this.lifeStyleAdviceRef = ref}}/>*/}
            {/*</div>*/}

            {
                isLC &&
                <div className={"save-button collapsible-card"}>
                    {/* Validate and Preview */}
                    <CTA innerText={this.props.appTenant === APP_TENANTS.SUGARFIT ? "Validate and End Consultation" : "Validate and Preview"} theme={CTATheme.PRIMARY} onClick={() => {
                        this.savePatientLifestylePlan();
                    }} customStyle={{ display: "inline" }} />
                    <CTA innerText={"Save in Draft and Exit"} theme={CTATheme.PRIMARY} onClick={() => {
                        this.savePatientLifestylePlanInDraft();
                    }} customStyle={{ display: "inline" }} />
                </div>
            }

            {
                !isLC &&
                <div className={"save-button collapsible-card"}>
                    {
                        AppUtils.isAILCConsultation(this.props.appointmentSchedule) &&
                        <input className="card-primary-action" type="button" value={"End"}
                            onClick={this.endAILCConsultation} />
                    }
                    {
                        !AppUtils.isAILCConsultation(this.props.appointmentSchedule) &&
                        <input className="card-primary-action" type="button" value={"Next"}
                            onClick={this.props.nextTab} />
                    }
                </div>
            }
        </div>
    }
}